// extracted by mini-css-extract-plugin
export default {"statusBadge":"StatusBadge_statusBadge__gBeu4"};